import { EmailOutlined } from "@mui/icons-material";
import { Dialog, List, Divider, SxProps, Theme } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import BodyText from "../../../components/BodyText";
import SubTitle from "../../../components/SubTitle";
import DialogListItem from "./DialogListItem";
import Transition from "./Transition";

interface Props {
  open: boolean;
  onClose: () => void;
  paperSx: SxProps<Theme>;
}

const CustomerSupportOverlay = ({ onClose: closeHandler, open, paperSx }: Props) => (
  <Dialog
    open={open}
    onClose={closeHandler}
    PaperProps={{
      elevation: 3,
      sx: paperSx,
    }}
    TransitionComponent={Transition}
  >
    <BodyText sx={{ fontWeight: 600, color: "#655B50",  mt: "10px", display: { xs: "flex", md: "none" } }}>Contact Customer Support</BodyText>
    <SubTitle sx={{ fontWeight: 600, color: "#655B50",  mt: "10px", display: { md: "flex", xs: "none" } }}>Contact Customer Support</SubTitle>
    <List sx={{ width: { xs: "100%", md: "80%" }, my: "4%" }}>
      <Divider variant="inset" component="li" />
      <DialogListItem
        icon={<SupportAgentIcon />}
        onArrowClick={() => {
          window.location.href = "tel:877 215 4741";
        }}
        primaryText="Call us"
        secondaryText="(877) 215-4741"
      />
      <Divider variant="inset" component="li" />
      <DialogListItem
        icon={<EmailOutlined />}
        onArrowClick={() => {
          window.location.href = "mailto:support@cosmotogether.com";
        }}
        primaryText="Email us"
        secondaryText="support@cosmotogether.com"
      />
    </List>
  </Dialog>
);
export default CustomerSupportOverlay;
